import React from 'react';
import PhoneInputComponent from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneInput.css';

interface PhoneInputProps {
  value: string;
  onChange: (value: string | undefined) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = "Enter phone number"
}) => {
  return (
    <div className="phone-input-container">
      <PhoneInputComponent
        value={value}
        onChange={onChange}
        defaultCountry="NZ"
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
};

export default PhoneInput;
